import { NODE_ENV } from '../../../../constants'

/**
 * True only inside the hermetic E2E stack (Vite `--mode e2e`, which sets `VITE_NODE_ENV=e2e`). When set, the
 * KYC screen renders an inert stub-completion control instead of mounting the live Sumsub WebSDK, so the
 * golden path can drive KYC completion offline with no traffic to Sumsub's servers.
 *
 * Inert everywhere else: in every real build `NODE_ENV` is 'production'/'development', so the live WebSDK
 * mounts exactly as before. Kept as a function (not a module-load constant) so screen tests can drive both
 * branches by mocking this module.
 */
export const isE2eKycStub = (): boolean => NODE_ENV === 'e2e'
